import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

import styled from '@xstyled/styled-components';
import { Card, Menu } from 'antd';
import { styleVariables } from '../../../style';
import { DefaultText } from '../../typography/text';
import { TextLinkButton } from '../../button';
import { LeftOutlined } from '@ant-design/icons';
import { UserAvatar } from '../user-avatar';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var Meta = Card.Meta;
// sidebar
var CollapseButton = styled(TextLinkButton)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  border: none;\n  height: 25px;\n  width: 25px;\n  border-radius: 50%;\n  box-shadow: 0px 1px 4px 1px rgba(0, 0, 0, 0.3);\n  left: 100%;\n  top: 3rem;\n  transform: translateX(-50%);\n  background-color: ", ";\n  cursor: pointer;\n"])), styleVariables.colors.gray1);
var StyledMenu = styled(Menu)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  border: none;\n  width: inherit;\n  overflow-y: auto;\n  box-shadow: inset -1px 0px 0px ", ";\n  overflow-x: hidden;\n  /* width */\n  ::-webkit-scrollbar {\n    width: 6px;\n  }\n  /* Track */\n  ::-webkit-scrollbar-track {\n    box-shadow: inset 0 0 3px ", ";\n    border-radius: 10px;\n  }\n  /* Handle */\n  ::-webkit-scrollbar-thumb {\n    background: ", ";\n    border-radius: 10px;\n  }\n  /* Handle on hover */\n  ::-webkit-scrollbar-thumb:hover {\n    background: ", ";\n  }\n  .ant-menu-title-content {\n    margin-left: 10px;\n  }\n  li.ant-menu-item {\n    .ant-menu-item-icon {\n      .ant-image {\n        height: 16px !important;\n      }\n    }\n  }\n  li.ant-menu-item.ant-menu-item-active {\n    a,\n    .ant-menu-item-icon {\n      color: ", ";\n    }\n    .ant-image {\n      img {\n        filter: invert(12%) sepia(83%) saturate(5841%) hue-rotate(244deg) brightness(87%)\n          contrast(153%);\n      }\n    }\n  }\n  li.ant-menu-item.ant-menu-item-selected {\n    a,\n    .ant-menu-item-icon {\n      font-style: normal;\n      font-weight: 600;\n      font-size: 16px;\n      color: ", ";\n    }\n    .ant-image {\n      img {\n        filter: invert(12%) sepia(83%) saturate(5841%) hue-rotate(244deg) brightness(87%)\n          contrast(153%);\n      }\n    }\n    ::after {\n      border-right-color: ", ";\n    }\n  }\n"])), styleVariables.colors.gray4, styleVariables.colors.gray4, styleVariables.colors.gray4, styleVariables.colors.gray4, styleVariables.colors.blue4, styleVariables.colors.blue4, styleVariables.colors.blue4);
var StyledTitleMenu = styled(DefaultText)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  a {\n    color: ", ";\n    font-size: 16px;\n    font-weight: 400;\n  }\n"])), styleVariables.colors.gray13);
var StyledCardUser = styled(Card)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  height: 100px;\n  border-bottom: none;\n  .ant-card-body {\n    padding: 32px 32px 32px 24px;\n  }\n  .ant-avatar {\n    background: ", ";\n  }\n"])), styleVariables.colors.gray6);
var StyledBottomTitle = styled.p(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  a {\n    font-size: 14px;\n    color: ", ";\n    font-weight: 600;\n  }\n"])), styleVariables.colors.gray10);
var StyledBottomMenu = styled(StyledMenu)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  width: 100%;\n  li.ant-menu-item {\n    .ant-menu-item-icon {\n      color: ", ";\n    }\n  }\n  li.ant-menu-item.ant-menu-item-selected {\n    a,\n    .ant-menu-item-icon {\n      font-style: normal;\n      font-weight: 600;\n      font-size: 14px;\n      color: ", ";\n    }\n  }\n"])), styleVariables.colors.gray10, styleVariables.colors.blue4);
export var MenuSideBar = function MenuSideBar(props) {
  var menuItems = props.menuItems,
      translation = props.translation,
      selectedKeys = props.selectedKeys,
      bottomMenuItems = props.bottomMenuItems,
      isLoadingUserInfo = props.isLoadingUserInfo,
      firstLetterOfUsername = props.firstLetterOfUsername,
      formattedUsername = props.formattedUsername,
      navigateToPath = props.navigateToPath,
      handleCollapse = props.handleCollapse,
      urlNavigateAccountSettingPage = props.urlNavigateAccountSettingPage;

  var renderRoutingMenuItem = function renderRoutingMenuItem(bottomMenuItem) {
    return bottomMenuItem.path && /*#__PURE__*/_jsx(StyledBottomTitle, {
      children: navigateToPath(bottomMenuItem.path, bottomMenuItem.title)
    });
  };

  var renderClickableMenuItem = function renderClickableMenuItem(bottomMenuItem) {
    return bottomMenuItem.onClick && /*#__PURE__*/_jsx(StyledBottomTitle, {
      onClick: bottomMenuItem.onClick,
      children: translation(bottomMenuItem.title)
    });
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(StyledMenu, {
      mode: "inline",
      selectedKeys: selectedKeys,
      children: [/*#__PURE__*/_jsx(StyledCardUser, {
        children: /*#__PURE__*/_jsx(UserAvatar, {
          isLoadingUserInfo: isLoadingUserInfo,
          urlNavigateAccountSettingPage: urlNavigateAccountSettingPage,
          firstLetterOfUsername: firstLetterOfUsername,
          formattedUsername: formattedUsername
        })
      }), menuItems && menuItems.map(function (menuItem) {
        return /*#__PURE__*/_jsx(Menu.Item, {
          icon: menuItem.icon,
          children: menuItem.path ? /*#__PURE__*/_jsx(StyledTitleMenu, {
            children: navigateToPath(menuItem.path, menuItem.title)
          }) : /*#__PURE__*/_jsx("a", {
            children: /*#__PURE__*/_jsx(DefaultText, {
              children: translation(menuItem.title)
            })
          })
        }, menuItem.key);
      })]
    }), typeof handleCollapse === 'function' ? /*#__PURE__*/_jsx(CollapseButton, {
      onClick: handleCollapse,
      children: /*#__PURE__*/_jsx(LeftOutlined, {})
    }) : /*#__PURE__*/_jsx("div", {}), /*#__PURE__*/_jsx(StyledBottomMenu, {
      mode: "inline",
      selectedKeys: selectedKeys,
      children: bottomMenuItems && bottomMenuItems.map(function (bottomMenuItem) {
        return /*#__PURE__*/_jsxs(Menu.Item, {
          icon: /*#__PURE__*/_jsx(StyledBottomTitle, {
            children: bottomMenuItem.icon
          }),
          children: [renderRoutingMenuItem(bottomMenuItem), renderClickableMenuItem(bottomMenuItem)]
        }, bottomMenuItem.key);
      })
    })]
  });
};